import style from "../../assets/scss/common/footer.module.scss";
import logoGray from "../../assets/images/logo/feelgoodLogoGray.svg";
import linkIcon from "../../assets/images/footer/link_icon.svg";
import bannerAdult from "../../assets/images/footer/banner_adult.png";
import bannerAdultMobile from "../../assets/images/footer/banner_adult_mobile.png";
import { Trans, useTranslation } from "react-i18next";
import { useFooter, useLanguage, usePage, useUserAgent } from "../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { NavigationButton } from "./button/NavigationButton";
import { Language } from "../../types/language";
import {QnA} from "../sub/QnA";

export function Footer() {
  const { showFooter } = useFooter();
  const { t } = useTranslation(["newFooter"]);
  const navigate = useNavigate();

  const { isDesktop, isTablet } = useUserAgent();
  const { isKorean, language, setLang } = useLanguage();
  const { isOrderPage, isDownloadTestPage, isWithAppPage, isSimpleTestPage, isMyPage } = usePage();

  const onClickDownloadButton = () => navigate(`/download-test`);

  return (
    <footer className={`${style.footer} ${showFooter ? style.show : ""}`}>
      <h1 className="blind">{t("footerHeading")}</h1>
      {!isOrderPage && !isDownloadTestPage && !isSimpleTestPage  && !isMyPage && (
        <div className={style.bannerWrapper}>
          <div className={style.banner}>
            <div className={style.textArea}>
              <p className={style.text}>
                {t("banner.text1")}
                <br />
                <span className={style.point}>
                  <Trans t={t} i18nKey={"banner.text2"} components={[<span className={style.strongPoint} />]} />
                  {isTablet ? <br /> : null}
                  <Trans t={t} i18nKey={"banner.text3"} components={[<span className={style.strongPoint} />]} />
                </span>
              </p>
              <NavigationButton buttonText={t("banner.download")} onClickEvent={onClickDownloadButton} />
            </div>
            <img className={style.image} src={isDesktop ? bannerAdult : bannerAdultMobile} alt={t("banner.imageAlt")} />
          </div>
        </div>
      )}
      <QnA />
      <div className={style.contentWrapper}>
        <div className={style.companyInfoAndLang}>
          {isDesktop ? (
            <></>
          ) : (
            <div className={style.companyLogo}>
              <a href="https://www.feel-good.io/" target="_blank" rel="noreferrer">
                <img src={logoGray} alt={t("logoAlt")} />
              </a>
            </div>
          )}
          <p className={style.companyInfo}>
            {isDesktop && isKorean ? (
              <>
                <span className={style.name}>{t("companyName")}</span>
                <br />
                <span className={style.others}>
                  {t("ceoLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;{t("ceoName")}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t("companyRegistrationNumberLabel")}
                  &nbsp;&nbsp;|&nbsp;&nbsp;397-81-01770&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t("businessLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;{t("businessNumber")}
                  <br />
                  {t("inquiryLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;MAIL : contact@feel-good.io
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {isKorean ? `전화  |  051-747-4050` : null}
                  {isKorean ? <br /> : null}
                  {t("busanAddress")}
                  <br />
                  {t("gyeonggiAddress")}
                </span>
              </>
            ) : (
              <>
                <span className={style.name}>{t("companyName")}</span>
                {isDesktop ? <br /> : <></>}
                <span className={style.others}>
                  {t("ceoLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;{t("ceoName")}
                  <br />
                  {t("companyRegistrationNumberLabel")}
                  &nbsp;&nbsp;|&nbsp;&nbsp;397-81-01770
                  <br />
                  {t("businessLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;{t("businessNumber")}
                  <br />
                  {t("inquiryLabel")}&nbsp;&nbsp;|&nbsp;&nbsp;MAIL : contact@feel-good.io
                  <br />
                  {isKorean ? `전화  |  051-747-4050` : null}
                  {isKorean ? <br /> : null}
                  {t("busanAddress")}
                  <br />
                  {t("gyeonggiAddress")}
                </span>
                {!isDesktop && (
                  <a className={style.link} href="https://www.feel-good.io/" target="_blank" rel="noreferrer">
                    <img className={style.icon} src={linkIcon} alt={t("blankLinkIconAlt")} />
                    <span>{t("companyHomepageLink")}</span>
                  </a>
                )}
              </>
            )}
          </p>
          {!isWithAppPage && (
            <div className={style.lang}>
              <label className={style.label}>Language</label>
              <select
                className={style.select}
                value={language}
                onChange={(e) => {
                  setLang(e.target.value as Language);
                  window.scrollTo(0, 0);
                }}
              >
                <option value={Language.KO}>{Language.toString(Language.KO)}</option>
                <option value={Language.EN}>{Language.toString(Language.EN)}</option>
                {/*<option value={Language.ZH}>{Language.toString(Language.ZH)}</option>*/}
                {/* <option value={Language.RU}>{Language.toString(Language.RU)}</option> */}
              </select>
            </div>
          )}
        </div>
        {isDesktop ? (
          <div className={style.logoWrapper}>
            <a className={style.companyLogo} href="https://www.feel-good.io/" target="_blank" rel="noreferrer">
              <img src={logoGray} alt={t("logoAlt")} />
            </a>
            <a className={style.link} href="https://www.feel-good.io/" target="_blank" rel="noreferrer">
              <img className={style.icon} src={linkIcon} alt={t("blankLinkIconAlt")} />
              <span>{t("companyHomepageLink")}</span>
            </a>
          </div>
        ) : (
          <></>
        )}
      </div>
    </footer>
  );
}
